import React, { useEffect, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { hasPhotoLikeComponent, toTop } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import Mask from '../Mask';
import ReactSVG from 'react-svg';
import stat from '../../utils/stat';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

interface ISettingPendantTypeList {
  type: string;
  name: string;
}

export interface ISettingButton {
  rootStore?: RootStore;
  isFold?: boolean;
  settingMask?: (status:boolean, callback?:()=>void)=>void;
}

// const settingMaskRef = window.document.createElement('div');
// settingMaskRef.className = 'pendant-setting-mask';

// 不期望wrapper rootStore
const SettingButton = (props: ISettingButton) => {
  const typeList = [
    {
      type: '1',
      name: intl.get('One Column')
    },
    {
      type: '2',
      name: intl.get('Two Column')
    },
    {
      type: '4',
      name: intl.get('Four Column')
    },
    {
      type: 'flow',
      name: intl.get('Timeline')
    },
    {
      type: 'waterfall',
      name: intl.get('Waterfall')
    }
  ];
  const { isFold } = props;
  const activeGallery = activeGalleryInstance.get();

  const [showLeft, setShowLeft] = useState(false);

  useEffect(() => {
    // 产品希望第一次打开的时候能够自动打开一下: 每个用户只提示这1次，再次进入其他子相册或其他相册，均不提示
    // if (!localStorage['hideShowSetting']) {
    //   localStorage['hideShowSetting'] = 1;
    //   setShowLeft(true);
    //   const timer = window.setTimeout(() => {
    //     setShowLeft(false);
    //   }, 1000);
    //   return () => {
    //     clearTimeout(timer);
    //   };
    // }
    if(isFold) {
      setShowLeft(true);
    }
  }, [isFold]);

  useEffect(() => {
    if (showLeft) {
      window.dispatchEvent(new Event('hide-video'));
    }

    return () => {

    };
  }, [showLeft]);

  const currentTypeIndex = typeList.findIndex(
    type => type.type === (activeGallery ? activeGallery.mode : '1')
  );
  const filteredTypeList = [
    ...typeList.slice(0, currentTypeIndex),
    ...typeList.slice(currentTypeIndex + 1)
  ];

  const hideMoreButton = () => {
    if (isFold) {
      let event = new Event('PENDENT_FOLD');
      event.data = true;
      window.dispatchEvent(event);
    }
  };

  const settingTypeClick = (type: string) => {
    activeGallery?.setMode(type);
    setShowLeft(false);
    stat.event('button_type');
    hideMoreButton();
  };
  const settingOrderClick = () => {
    toTop();
    activeGallery?.setOrder();
    stat.event('button_sort');
    activeGallery?.reload({
      orderchange: true,
      notmerge: true,
      sortOrder: activeGallery.order
    });
    setShowLeft(false);
    hideMoreButton();
  };

  const { componentColor, backgroundColor, mainColor } = useContext(
    ThemeContext
  );
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);
  const [visible, setVisible] = useState(false);

  const canShowGalleryButtons = () => {
    // tagphoto 自己携带 gallery_list，不要再依赖页面的 data 绑定。
    return hasPhotoLikeComponent(window.pageDetail.template || []);
  };

  useEffect(() => {
    // 初始检测
    setVisible(canShowGalleryButtons());

    const notifyButtonsChange = (e: any) => {
      let action = (e.action || '') as string;
      if (action == 'tab_no_photo') {
        setVisible(false);
      }
      if (action == 'tab_has_photo') {
        setVisible(true);
      }
    };

    window.addEventListener('PENDENT_CHANGE', notifyButtonsChange);

    return () => {
      window.removeEventListener('PENDENT_CHANGE', notifyButtonsChange);
    };
  }, []);

  // useEffect(()=>{
  //   if(props.settingMask && !isFold) {
  //     if(!!showLeft) {
  //       props.settingMask(true, ()=>{
  //         setShowLeft(false);
  //       });
  //     }else {
  //       props.settingMask(false);
  //     }
  //   }
  // }, [showLeft, isFold]);

  return (
    <div className={`pendant-row ${!visible ? 'hide' : ''}`}>

      <div className={classNames('setting-left-wrapper', { hide: !showLeft })}>
        <div
          className={classNames('setting-left')}
          style={{
            color: pendantIconColor,
            backgroundColor: pendantBgColor
          }}
        >
          <div className="gallery-type-group">
            {filteredTypeList.map(one => (
              <div
                className="one-item"
                key={one.type}
                onClick={() => settingTypeClick(one.type)}
              >
                {one.name}
              </div>
            ))}
          </div>
          <div
            className="vertical-line"
            style={{ backgroundColor: pendantBgColor }}
          />
          <div className="one-item" onClick={settingOrderClick}>
            {activeGallery && activeGallery.order === 'asc' ? intl.get('DESC') : intl.get('ASC')}
          </div>
        </div>
        <div className="triangle" style={{ borderLeftColor: pendantBgColor }} />
      </div>
      <div
        className="pendent-row"
        onClick={() => {
          setShowLeft(prevState => !prevState);
        }}
      >
        <div
          className="pendent-normal setting-button"
          style={{
            fill: pendantIconColor,
            backgroundColor: pendantBgColor
          }}
        >
          <ReactSVG
            src={require('../../svg/icon-setting.svg')}
            style={{ width: 18, height: 18 }}
          />
        </div>
      </div>
    </div>
  );
};

export default inject('rootStore')(observer(SettingButton));
